import QueryKeys from "../api/queryKeys";
import { ISODateString } from "../types/date";

export const QueryKeyBuilder = {
  Attendance: (groupId: number) => [QueryKeys.Attendance, groupId],
  MidweekSubs: (groupId: number, from: ISODateString, to: ISODateString) => [QueryKeys.MidweekSubs, groupId, from, to],
  // noSubs must be part of the key: the on-screen schedule fetches with noSubs=true (it applies
  // substitutions itself client-side) while print/export fetch with noSubs=false (pre-merged by the
  // backend) — without this, ensureQueryData in the export/print paths can silently reuse the
  // on-screen view's cached noSubs=true data for the same date range, dropping substitutions and
  // supplemental parts from prints/exports.
  MidweekInfo: (groupId: number, from: ISODateString, to: ISODateString, noSubs: boolean) => [
    QueryKeys.MidweekInfo,
    groupId,
    from,
    to,
    noSubs,
  ],
  CustomAssignments: (from: ISODateString, to: ISODateString) => [QueryKeys.CustomAssignments, from, to],
};
